import { render, staticRenderFns } from "./StatementsComponent.vue?vue&type=template&id=4d199288&scoped=true"
import script from "./StatementsComponent.vue?vue&type=script&lang=js"
export * from "./StatementsComponent.vue?vue&type=script&lang=js"
import style0 from "./StatementsComponent.vue?vue&type=style&index=0&id=4d199288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d199288",
  null
  
)

export default component.exports